"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.Holder=exports.HeadingWrapper=exports.Heading=exports.Header=exports.CardWraper=exports.CardHeader=exports.ButtonContainer=void 0;const CardWraper=exports.CardWraper=_styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:start;
  margin:16px 0;
  pointer-events: none;
`,HeadingWrapper=exports.HeadingWrapper=_styledComponents.default.div`
  width: 100%;
  text-align: left;
`,Holder=exports.Holder=_styledComponents.default.div`
  margin-left:-13px;
`,Header=exports.Header=_styledComponents.default.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
`,Heading=exports.Heading=_styledComponents.default.div`
  font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
  font-size: 20px;
  margin: 24px 0px 24px 0px;
  display: flex;
  align-items: center;
`,ButtonContainer=exports.ButtonContainer=_styledComponents.default.div`
  display: flex;
  justify-content: center;
  width:327px;
`,CardHeader=exports.CardHeader=_styledComponents.default.h1`
  font-style: normal;
  font-size: 28px;
  color: #2a2928;
  display: unset;
  font-weight: unset;
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-end: unset;
  margin-inline-start: unset;
`;